import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { installKerningPatch } from './lib/textKerningPatch';

installKerningPatch();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
